import styled from "styled-components";

export const SubtitleDiv = styled.div`
  margin: 25px 0 50px 0;
  padding: 0 50px;
  & h3 {
    font-weight: 400;
    font-size: 24px;
    line-height: 36px;
  }
  @media (max-width: 767px) {
    padding: 0 25px;
    & h3 {
      font-size: 18px;
    }
  }
`;

export const SelectionCommitteeDiv = styled.div`
  & h3 {
    /* text-align: center; */
    margin: 25px 100px;
  }
`;

export const ResearchersDiv = styled.div`
  background-color: var(--white);
  padding-top: 25px;
  margin-top: 50px;
  position: relative;
  z-index: 1;
  &:before {
    position: absolute;
    left: -100vw;
    right: -100vw;
    top: 0;
    bottom: 0;
    content: "";
    background-color: var(--white);
    z-index: 0;
    mix-blend-mode: darken;
  }
  & h3 {
    margin: 25px 100px;
    z-index: 2;
  }
  & > div {
    z-index: 2;
  }
`;

export const ArticleBodyWrapper = styled.div`
  background-color: var(--white);
  padding: 25px 0;
  margin-top: 25px;
  & > div {
  }
`;

export const AboutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  & h3 {
    padding: 0 50px;
    max-width: calc(
      calc(var(--width) - var(--outerMargin)) - var(--outerMargin)
    );
    margin: 25px 0;
  }
  @media (max-width: 767px) {
    & h3 {
      margin: 0;
      padding: 0;
      font-size: 24px;
    }
  }
`;

export const FoundationFrontText = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(calc(var(--width) - var(--outerMargin)) - var(--outerMargin));
  margin: 30px auto 50px auto;
  & p {
    margin: 0;
    font-weight: 400;
    font-size: 24px;
    line-height: 36px;
    letter-spacing: 0.32px;
    font-family: 'Euclid Circular A' !important;
    & + p {
      margin-top: 36px;
    }
  }
  @media (max-width: 767px) {
    & p {
      font-size: 18px;
      line-height: 28px;
    }
  }
`;

export const LearningDiv = styled.div`
  max-width: 600px;
  margin: 25px auto 50px auto;
  & h4 {
    color: var(--purple);
    margin-bottom: 20px;
  }
`;
